/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventdescriptionlanguagelocked3Inputs */

const en_eventdescriptionlanguagelocked3 = /** @type {(inputs: Eventdescriptionlanguagelocked3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn off the second language first to change the original language.`)
};

const de_eventdescriptionlanguagelocked3 = /** @type {(inputs: Eventdescriptionlanguagelocked3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schalte zuerst die zweite Sprache aus, um die Originalsprache zu wechseln.`)
};

/**
* | output |
* | --- |
* | "Turn off the second language first to change the original language." |
*
* @param {Eventdescriptionlanguagelocked3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventdescriptionlanguagelocked3 = /** @type {((inputs?: Eventdescriptionlanguagelocked3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventdescriptionlanguagelocked3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventdescriptionlanguagelocked3(inputs)
	return de_eventdescriptionlanguagelocked3(inputs)
});
export { eventdescriptionlanguagelocked3 as "eventDescriptionLanguageLocked" }